// extracted by mini-css-extract-plugin
export var headerInfo = "Newsletter-module--headerInfo--nSeQg";
export var newsletterContainer = "Newsletter-module--newsletterContainer--Cqm6D";
export var newsletterContent = "Newsletter-module--newsletterContent--kA15J";
export var newsletterFormContainer = "Newsletter-module--newsletterFormContainer--FJyYC";
export var newsletterPattern = "Newsletter-module--newsletterPattern--KwDk+";
export var page404Title = "Newsletter-module--page404-title--KtE1V";